/**
 * KanbanTest Component
 * Test component for debugging kanban board statuses
 * Displays dropdown data and API responses
 */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTicketDropdowns } from '../../store/ticketSlice';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { COLORS } from '../../shared/colors';

const KanbanTest = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { dropdowns, dropdownsLoading, error } = useSelector(state => state.tickets);

  useEffect(() => {
    dispatch(fetchTicketDropdowns());
  }, [dispatch]);

  if (dropdownsLoading) {
    return <Typography>{t('kanbanTest.loadingDropdowns')}</Typography>;
  }

  if (error) {
    return <Typography color="error">{t('kanbanTest.error')} {error}</Typography>;
  }

  return (
    <Box p={2}>
      <Typography variant="h5" mb={2}>{t('kanbanTest.kanbanStatusTest')}</Typography>
      
      <Typography variant="h6" mb={1}>{t('kanbanTest.availableStatuses')}</Typography>
      <Box display="flex" gap={2} flexWrap="wrap" mb={3}>
        {dropdowns.statuses.map((status) => (
          <Card key={status.id} sx={{ minWidth: 120 }}>
            <CardContent sx={{ p: 1 }}>
              <Typography variant="body2" fontWeight="bold">
                {status.name}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {t('kanbanTest.id')} {status.id}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>

      <Typography variant="h6" mb={1}>{t('kanbanTest.rawApiResponse')}</Typography>
      <Box component="pre" sx={{ bgcolor: COLORS.gray[100], p: 2, borderRadius: 1, fontSize: '12px', overflow: 'auto' }}>
        {JSON.stringify(dropdowns, null, 2)}
      </Box>
    </Box>
  );
};

export default KanbanTest;